module.exports = __webpack_public_path__ + "media/bundles/ReactHome/components/layout/spinner-22555b55def970341edff4aece6671fa.gif";